import { SideSellersSearch } from "@/components/inputs/SideSellersSearch";
import SiteLayout from "@/components/layouts/SiteLayout";
import { PaginatedSellersList } from "@/components/sellers/PaginatedSellers";
import SellerController from "@/server/controllers/SellerController";
import UserService from "@/server/services/user/UserService";
import CommonUtils from "@/utils/CommonUtils";
import SellerHelper from "@/utils/SellersHelper";
import { useState } from "react";

export async function getServerSideProps(context) {
  const queryParams = context.query;
  let page = queryParams.page ? parseInt(queryParams?.page) : 1;
  let pageSize = 12;
  let sellersData = await SellerController.getAllWithLocationsPaginated(
    page,
    pageSize,
    context
  );

  let user = await UserService.getLoggedInUser(context.req);

  let userIsAdmin = false;

  if (user?.userType == "admin") {
    userIsAdmin = true;
  }

  sellersData = JSON.parse(JSON.stringify(sellersData));
  const locale = context.locale;
  let queryInfo = await SellerHelper.getQueryPramsInfo(queryParams, locale);
  return { props: { sellersData, queryParams, userIsAdmin, queryInfo } };
}

const Sellers = ({ sellersData, queryParams, userIsAdmin, queryInfo }) => {
  const [showFilter, setShowFilter] = useState(true);
  const toggleFilter = () => {
    setShowFilter(!showFilter);
    if (document.getElementById("navigation")) {
      var elements: any = document
        .getElementById("navigation")
        ?.getElementsByTagName("a");

      for (var i = 0, len = elements?.length; i < len; i++) {
        elements[i].onclick = function (elem) {
          if (elem.target.getAttribute("href") !== "") {
            if (elem.target.nextElementSibling) {
              var submenu = elem.target.nextElementSibling.nextElementSibling;
              submenu.classList.toggle("open");
            }
          }
        };
      }
    }
  };
  return (
    <SiteLayout
      title={queryInfo.seoTitle + " | " + CommonUtils.appName}
      description={queryInfo.seoDescription}
    >
      <div className="container mx-auto sm:mt-auto -mt-[40px]">
        <div className="md:space-x-4">
          <div className=" mb-20">
            <SideSellersSearch queryParams={queryParams} />
          </div>
          <div className="flex-1">
            <PaginatedSellersList
              sellers={sellersData.data}
              gridClass={`gap-8 grid grid-cols-1 lg:!grid-cols-3  md:!grid-cols-2`}
              currentPage={sellersData.page}
              queryParams={queryParams}
              queryInfo={queryInfo}
              hasNext={sellersData.hasNext}
              hasPrevious={sellersData.hasPrevious}
              totalPages={sellersData.totalPages}
              userIsAdmin={userIsAdmin}
            />
          </div>
        </div>
      </div>
    </SiteLayout>
  );
};

export default Sellers;
